import React from "react";
import PropTypes from "prop-types";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import FormTextarea from "Common/Custom/FormTextarea";

const EditCandidateSelectionForm = ({
    fields,
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    title,
    CandidateOptions,
    PositionOptions,
}) => {
    const optionConfig = {
        can_id: {
            list: CandidateOptions,
            valueKey: "id",
            labelKey: "name",
        },
        pos_id: {
            list: PositionOptions,
            valueKey: "position_id",
            labelKey: "position_name",
        },
    };

    const renderField = (field) => {
        if (field.type === "select") {
            return (
                <FormSelect
                    key={field.name}
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    options={getSelectOptions(field.name, optionConfig)}
                    error={errors[field.name]}
                />
            );
        }

        if (field.type === "textarea") {
            return (
                <FormTextarea
                    field={field}
                    value={values[field.name]}
                    handleChange={handleChange}
                    error={errors[field.name]}
                />
            );
        }

        return (
            <FormInput
                key={field.name}
                field={field}
                value={values[field.name]}
                handleChange={handleChange}
                error={errors[field.name]}
            />
        );
    };

    return (
        <PageBody
            onSubmit={handleSubmit}
            headerchildren={<HeadingOne>{title}</HeadingOne>}
        >
            {fields.map((field) => renderField(field))}

            <FormSubmitButton
                label="Update"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

EditCandidateSelectionForm.propTypes = {
    fields: PropTypes.array.isRequired,
    values: PropTypes.object.isRequired,
    errors: PropTypes.object,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    title: PropTypes.string,
    CandidateOptions: PropTypes.array,
    PositionOptions: PropTypes.array,
};

EditCandidateSelectionForm.defaultProps = {
    errors: {},
    loading: false,
    title: "Edit Candidate Selection",
    CandidateOptions: [],
    PositionOptions: [],
};

export default EditCandidateSelectionForm;
